import { createFormContext } from "@mantine/form";
import type { PronosticV2 } from "pronosticsv2/types/pronosticv2.model";

export const [
  PronosticV2FormProvider,
  usePronosticV2FormContext,
  usePronosticV2Form,
] = createFormContext<Omit<PronosticV2, "id">>();
